import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Duck type the given value to determine if this is an Error or a descendent of Error.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Enumerability_and_ownership_of_properties#detection_table
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export var isErrorLike = function isErrorLike(value) {
  if (_typeof(value) === 'object') {
    /* Note that while .hasOwnProperty('message') will work for instances of `Error`, it will fail
    for instances of classes that extend `Error` (i.e., custom Errors of the form
    `MyError extends Error`). */
    return typeof value.message !== 'undefined' && typeof value.stack !== 'undefined';
  }

  return false;
};